import { useFormik } from 'formik';
import { FormGroup } from 'shared-components';
import * as yup from 'yup';
import { Button } from 'shared-components';
import { useCreateEventMutation } from './events.api';
import { toast } from 'react-toastify';
import { close } from '../modal/modalSlice';
import { useAppDispatch } from '../../app/hooks';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';

export const EventCreateForm = () => {
  const dispatch = useAppDispatch();
  const [createEvent] = useCreateEventMutation();
  const { getFieldProps, handleSubmit } = useFormik<{
    name: string;
    date: string;
  }>({
    initialValues: {
      name: '',
      date: new Date().toISOString().split('T')[0],
    },
    validationSchema: yup.object({
      name: yup.string().required(),
      date: yup
        .date()
        .transform((s) => new Date(s))
        .required(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      await createEvent({
        ...values,
        date: new Date(values.date),
      });
      toast.success('Event created!');
      dispatch(close());
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <FormLayout>
        <FormGroup>
          <Label htmlFor="name">Name</Label>
          <Input {...getFieldProps('name')} type="text" id="name" />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="date">Date</Label>
          <Input {...getFieldProps('date')} type="date" id="date" />
        </FormGroup>
        <FormGroup>
          <Button type="submit">Create</Button>
        </FormGroup>
      </FormLayout>
    </form>
  );
};
